const React = require('react')
const {
    createContext,
    useContext,
    useEffect,
    useCallback,
    useRef
} = require('react')
const io = require('socket.io-client')
const { TOKEN_NAME, API } = require('@configs')

const socketContext = createContext()

const useSocketHook = () => useContext(socketContext)

const createSocketConnection = () => {
    const socketInstanceRef = useRef()
    const authToken = localStorage.getItem(TOKEN_NAME)

    useEffect(() => {
        let isComponentUnmounted = false

        const initializeSocket = async () => {
            try {
                if (!isComponentUnmounted) {
                    socketInstanceRef.current = io.connect(API, {
                        query: { token: authToken }
                    })
                }
            } catch (error) {
                if (!isComponentUnmounted) {
                    throw error
                }
            }
        }

        initializeSocket()

        return () => {
            isComponentUnmounted = true
        }
    }, [])

    const listenToSocketEvent = useCallback((eventName = '', eventHandler) => {
        socketInstanceRef.current.on(eventName, data => eventHandler(data))
    }, [])

    const emitSocketEvent = useCallback((eventName, eventData) => {
        socketInstanceRef.current.emit(eventName, eventData)
    }, [])

    return {
        listenToSocketEvent,
        emitSocketEvent
    }
}

const SocketProvider = ({ children }) => {
    return (
        <socketContext.Provider value={createSocketConnection()}>
            {children}
        </socketContext.Provider>
    )
}

module.exports = {
    SocketProvider,
    useSocketHook
}
